<div class="carousel">
    <div class="cards-section">
        <p-carousel [value]="products" [numVisible]="1" [numScroll]="1" [circular]="false">
            <ng-template let-product #item>
                <div class="item flex flex-col justify-between">
                    <div>
                        <img class="vector" src="../../../assets/images/Vector.svg" />
                        <div class="desc">{{ product.description }}</div>
                    </div>
                    <div class="fix-section">
                        <div class="leader">
                            <div class="name">{{product.leader}}</div>
                            <div class="position">{{product.position}}</div>
                        </div>
                        <div class="stars">
                            <img src="../../../assets/images/clients-say/Stars.png" /><span>5.0</span>
                        </div>
                        <div class="flex justify-between footer">
                            <div class="flex flex-col">
                                <span>Business Area</span>
                                <span>{{product.businessArea}}</span>
                            </div>
                            <img [src]="product.image" />
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
    </div>
    <div class="text-section flex justify-center">
        <span>Trusted by the biggest brands:</span>
    </div>
    <div class="image-section flex justify-between">
        <img src="../../../assets/images/heartland.svg" />
        <img src="../../../assets/images/xenial.svg" />
        <img src="../../../assets/images/away.svg" />
        <img src="../../../assets/images/ezidebit.svg" />
        <img src="../../../assets/images/sentral.svg" />
    </div>
</div>
